import { useState } from "react";

export const useData = ({ defaults = {}, validators = {} }) => {
  const [values, setValues] = useState({ ...defaults });

  const set = (key, value) => {
    const newValues = { ...values };
    newValues[key] = value;
    setValues(newValues);
  };

  const setMany = (updatedValues) => {
    const newValues = { ...values, ...updatedValues };
    setValues(newValues);
  };

  const get = (key) => {
    return values[key];
  };

  const testPasses = (status) =>
    typeof status === "boolean" ? status : status[0];

  const feedback = (key) => {
    const DEFAULT_INVALID = "Tarkista kentän sisältö!";
    const validator = validators[key];
    if (!validator) return true;
    const value = values[key];
    if (value === undefined) return false;
    const status = validator(value, values);
    const passes = typeof status === "boolean" ? status : status[0];
    return typeof status === "boolean"
      ? passes
        ? ""
        : DEFAULT_INVALID
      : status[1];
  };

  const isValid = (key) => {
    const validator = validators[key];
    if (!validator) return true;
    const value = values[key];
    if (value === undefined) return false;
    const status = validator(value, values);

    return testPasses(status);
  };

  const hasValidData = (requiredFields) => {
    const fields = requiredFields ?? Object.keys(values);
    return fields.reduce((status, key) => {
      if (!status) {
        return false;
      }

      const validator = validators[key];
      if (!validator) {
        console.warn(`Missing validator for ${key}`);
        return true;
      }
      const result = isValid(key);
      if (!result) console.log(`${key} fails validation`);
      return result;
    }, true);
  };

  const getQueryData = (requiredFields) => {
    const fields = requiredFields ?? Object.keys(values);
    return fields.reduce((prev, key) => {
      const value = values[key];
      const n = { ...prev };
      n[key] = value;
      return n;
    }, {});
  };

  return {
    feedback,
    values,
    setValues,
    validators,
    isValid,
    hasValidData,
    getQueryData,
    get,
    set,
    setMany,
  };
};
